import { Component } from '@angular/core';
import { detectBody } from '../../../app.helpers';

declare var jQuery:any;

@Component({
  selector: 'agent',
  templateUrl: 'agentLayout.template.html',
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class AgentLayoutComponent {

  public ngOnInit():any {
    detectBody();
  }

  public onResize(){
    detectBody();
  }

}
